"use client";

import * as React from "react";

import type { ErrorLocaleCatalog } from "../errors/locales/types";

const ErrorLocaleContext = React.createContext<ErrorLocaleCatalog | undefined>(
  undefined,
);

/**
 * Every `ErrorNotice` below renders its copy in this language. Pass
 * `errorLocaleCatalog(locale)` from `@order-up/common/error-locales`; an
 * undefined catalog (English, or no preference) renders the English catalog,
 * which is also what an `ErrorNotice` with no provider above it does.
 *
 * Takes the catalog rather than a locale code so this file — and
 * `ErrorNotice`, which reads it — never imports the translations: an app that
 * does not localize ships none of them.
 */
export function ErrorLocaleProvider({
  catalog,
  children,
}: {
  catalog: ErrorLocaleCatalog | undefined;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <ErrorLocaleContext.Provider value={catalog}>
      {children}
    </ErrorLocaleContext.Provider>
  );
}

/** The error copy language in effect here; undefined means English. */
export function useErrorLocale(): ErrorLocaleCatalog | undefined {
  return React.useContext(ErrorLocaleContext);
}
